<div class="modal-header">
    <h5 class="modal-title">Sync Favorites</h5>
    <button type="button" class="btn-close" (click)="dismiss()" aria-label="Close"></button>
</div>
<dirty-tracking [forms]="[userForm]"></dirty-tracking>
<form novalidate #userForm="ngForm" [ngClass]="{'was-validated': submitAttempt}">
    <div class="modal-body">
        <div class="row gx-2 mb-4">
            <div class="col-md mb-3 mb-md-0 mobiscroll-select">
                <label class="form-label d-block">Users</label>
                <input id="move-account-input" class="mobi-input form-control form-control-lg" placeholder="Select Users" mbsc-select [data]="users" [(ngModel)]="userIds" name="accountId" [mbscOptions]="userOptions" />
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-black btn-round btn-lg" (click)="dismiss()"><i class="far fa-times"></i> Cancel</button>
        <button type="submit" class="btn btn-secondary btn-round btn-lg" (click)="save()"><i class="far fa-check"></i> Save</button>
    </div>
</form>